import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        updateForm: '=',
        question: '=',
        update: '&',
        cancel: '&'
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.cancel()"></button>
            <h2>{{ 'general.Manage translations' | translate }}</h2>
        </div>
        <div class="modal-body form translation">
            <form-wrapper form="vm.form">
                <div ng-if="vm.form.errors" ng-repeat="error in vm.generalErrors" class="alert alert-danger">{{ error }}</div>
                <table class="data01">
                    <tr>
                        <th>{{ 'general.Label ' | translate }}</th>
                        <th>{{ vm.defaultLanguage }} <small>({{ 'translation.default' | translate}})</small></th>
                        <th ng-repeat="(code, value) in vm.languages" ng-if="code!==vm.defaultLanguage">
                            <label><input type="checkbox" ng-model="vm.languages[code]"
                            ng-click="vm.toggleCheckbox(code)"> {{ code }}</label>
                        </th>
                    </tr>
                    <tr>
                        <td>{{ 'translation.Question name' | translate }}*</td>
                        <td class="input active">
                            <form-row-wide error="vm.form.errors.questionI18ns[vm.defaultLanguage].name">
                                <div class="items">
                                    <ng-ckeditor
                                        ng-model="vm.form.model.questionI18ns[vm.defaultLanguage].name"
                                        class="mt10"
                                        ng-config="vm.ckconfigForName">
                                    </ng-ckeditor>
                                    <form-row-wide-error></form-row-wide-error>
                                </div>
                            </form-row-wide>
                        </td>
                        <td class="input" ng-repeat="(code, value) in vm.languages" ng-if="code!==vm.defaultLanguage" ng-class="{'active': value}">
                            <form-row-wide error="vm.form.errors.questionI18ns[code].name">
                                <div class="items">
                                    <ng-ckeditor
                                        ng-model="vm.form.model.questionI18ns[code].name"
                                        ng-if="value"
                                        class="mt10"
                                        ng-config="vm.ckconfigForName">
                                    </ng-ckeditor>
                                    <form-row-wide-error></form-row-wide-error>
                                </div>
                            </form-row-wide>
                        </td>
                    </tr>
                    <tr>
                       <td>{{ 'translation.Question hint' | translate }}</td>
                       <td class="input active">
                           <form-row-wide error="vm.form.errors.questionI18ns[vm.defaultLanguage].hint">
                               <div class="items">
                                    <textarea ng-model="vm.form.model.questionI18ns[vm.defaultLanguage].hint" ng-attr-name="vm.form.model.questionI18ns[{{vm.defaultLanguage}}].hint"
                                       type="text" class="form-control"></textarea>
                                   <form-row-wide-error></form-row-wide-error>
                               </div>
                           </form-row-wide>
                       </td>
                       <td class="input" ng-repeat="(code, value) in vm.languages" ng-if="code!==vm.defaultLanguage" ng-class="{'active': value}">
                           <form-row-wide error="vm.form.errors.questionI18ns[code].hint">
                               <div class="items">
                                    <textarea ng-model="vm.form.model.questionI18ns[code].hint" ng-attr-name="vm.form.model.questionI18ns[{{code}}].hint"
                                       type="text" class="form-control" ng-if="value"></textarea>
                                   <form-row-wide-error></form-row-wide-error>
                               </div>
                           </form-row-wide>
                       </td>
                    </tr>
                    <tr>
                        <td>{{ 'translation.Question feedback' | translate }}</td>
                        <td class="input active">
                            <form-row-wide error="vm.form.errors.questionI18ns[vm.defaultLanguage].feedback">
                                <div class="items">
                                    <ng-ckeditor
                                        ng-model="vm.form.model.questionI18ns[vm.defaultLanguage].feedback"
                                        class="mt10"
                                        ng-config="vm.ckconfig">
                                    </ng-ckeditor>
                                    <form-row-wide-error></form-row-wide-error>
                                </div>
                            </form-row-wide>
                        </td>
                        <td class="input" ng-repeat="(code, value) in vm.languages" ng-if="code!==vm.defaultLanguage" ng-class="{'active': value}">
                            <form-row-wide error="vm.form.errors.questionI18ns[code].feedback">
                                <div class="items">
                                    <ng-ckeditor
                                        ng-if="value"
                                        ng-model="vm.form.model.questionI18ns[code].feedback"
                                        class="mt10"
                                        ng-config="vm.ckconfig">
                                    </ng-ckeditor>
                                    <form-row-wide-error></form-row-wide-error>
                                </div>
                            </form-row-wide>
                        </td>
                    </tr>
                    <tr ng-repeat="(key, value) in vm.form.model.childQuestions">
                       <td>{{ 'translation.Child question:' | translate }} {{ $index + 1 }}</td>
                       <td class="input active">
                           <form-row-wide error="vm.form.errors.childQuestions[$index].questionI18ns[vm.defaultLanguage]">
                               <div class="items">
                                   <input ng-model="vm.form.model.childQuestions[$index].questionI18ns[vm.defaultLanguage].name" ng-if="value" class="form-control">
                                   <form-row-wide-error></form-row-wide-error>
                               </div>
                           </form-row-wide>
                       </td>
                       <td class="input" ng-repeat="(code, value) in vm.languages" ng-if="code!==vm.defaultLanguage" ng-class="{'active': value}">
                           <form-row-wide error="vm.form.errors.childQuestions[key].questionI18ns[code].name">
                               <div class="items">
                                   <input ng-model="vm.form.model.childQuestions[key].questionI18ns[code].name" ng-if="value" class="form-control">
                                   <form-row-wide-error></form-row-wide-error>
                               </div>
                           </form-row-wide>
                       </td>
                    </tr>
                    <tr ng-repeat="(key, value) in vm.defaultLanguageAnswers">
                       <td>{{ 'translation.Answer' | translate }} {{ $index + 1 }}</td>
                       <td class="input active">
                           <form-row-wide error="vm.form.errors.questionAnswers[$index].translations[vm.defaultLanguage].text">
                               <div class="items">
                                    <textarea ng-model="vm.form.model.questionAnswers[$index].translations[vm.defaultLanguage].text"
                                       type="text" class="form-control"></textarea>
                                   <form-row-wide-error></form-row-wide-error>
                               </div>
                           </form-row-wide>
                           <form-row-wide ng-if="vm.isCheckboxOrRadio()" error="vm.form.errors.questionAnswers[$index].translations[vm.defaultLanguage].feedback">
                                <div class="items">
                                    <span><br>{{ 'translation.Answer feedback' | translate }}</span>
                                    <ng-ckeditor
                                        ng-model="vm.form.model.questionAnswers[$index].translations[vm.defaultLanguage].feedback"
                                        class="mt10"
                                        ng-config="vm.ckconfig">
                                    </ng-ckeditor>
                                    <form-row-wide-error></form-row-wide-error>
                                </div>
                            </form-row-wide>
                       </td>
                       <td class="input" ng-repeat="(code, value) in vm.languages" ng-if="code!==vm.defaultLanguage" ng-class="{'active': value}">
                           <form-row-wide error="vm.form.errors.questionAnswers[key].translations[code].text">
                               <div class="items">
                                    <textarea ng-model="vm.form.model.questionAnswers[key].translations[code].text"
                                       type="text" class="form-control" ng-if="value"></textarea>
                                   <form-row-wide-error></form-row-wide-error>
                               </div>
                           </form-row-wide>
                           <form-row-wide ng-if="vm.isCheckboxOrRadio()" error="vm.form.errors.questionAnswers[key].translations[code].feedback">
                                <div class="items">
                                    <span ng-if="value"><br>{{ 'translation.Answer feedback' | translate }}</span>
                                    <ng-ckeditor
                                        ng-if="value"
                                        ng-model="vm.form.model.questionAnswers[key].translations[code].feedback"
                                        class="mt10"
                                        ng-config="vm.ckconfig">
                                    </ng-ckeditor>
                                    <form-row-wide-error></form-row-wide-error>
                                </div>
                            </form-row-wide>
                       </td>
                    </tr>
                    <tr ng-repeat="(key, metaFieldId) in vm.metaFieldIds">
                       <td>{{ vm.form.model.questionMetaFields[metaFieldId].name }}</td>
                       <td class="input active">
                           <form-row>
                               <div class="items">
                                    <textarea ng-model="vm.questionMetaToTranslate[vm.defaultLanguage][$index].value"
                                       type="text" class="form-control"></textarea>
                                   <form-row-wide-error></form-row-wide-error>
                               </div>
                           </form-row-wide>
                       </td>
                       <td class="input" ng-repeat="(code, value) in vm.languages" ng-if="code!==vm.defaultLanguage" ng-class="{'active': value}">
                           <form-row>
                               <div class="items">
                                    <textarea ng-model="vm.questionMetaToTranslate[code][key].value"
                                       type="text" class="form-control" ng-if="value"></textarea>
                                   <form-row-wide-error></form-row-wide-error>
                               </div>
                           </form-row-wide>
                       </td>
                    </tr>
                </table>
            </form-wrapper>
        </div>
        <div class="modal-footer">
        <ul class="actions01">
            <li class="primary"><button class="btn main" type="button" ng-click="vm.save()">{{ 'general.Save' | translate }}</button></li>
            <li><button class="btn discrete" type="button" ng-click="vm.cancel()">{{ 'general.Cancel' | translate }}</button></li>
        </ul>
        </div>
    `
})
export default class {
    constructor ($scope, $translate, lodash, TokenService, ModalService,
                 QuestionConfirmService, QuestionFormService, CkEditorService, FormFactory,
                 QUESTIONS_TYPE_ENUM, FORMS_SITE_ACCESS_ENUM) {
        this.$scope = $scope;
        this.$translate = $translate;
        this.lodash = lodash;
        this.TokenService = TokenService;
        this.ModalService = ModalService;
        this.QuestionConfirmService = QuestionConfirmService;
        this.QuestionFormService = QuestionFormService;
        this.CkEditorService = CkEditorService;
        this.QUESTIONS_TYPE_ENUM = QUESTIONS_TYPE_ENUM;
        this.FORMS_SITE_ACCESS_ENUM = FORMS_SITE_ACCESS_ENUM;

        this.form = FormFactory.createFromResource(this.updateForm.model, {
            expand: 'questionI18ns,pool,category,author,questionAnswers,questionMeta,tags,metaGroups,questionAnswersI18ns,questionMetaFields,childQuestions,childQuestionsActiveI18ns,sites'
        });
    }

    $onInit () {
        const { lodash } = this;
        this.defaultLanguage = this.TokenService.getCompanyLanguage();

        // filter out only text metas
        this.questionMetaToTranslate = lodash.filter(this.form.model.questionMeta, (metaItem) => {
            return metaItem.value !== null;
        });

        this.metaFieldIds = lodash.keys(lodash.groupBy(this.questionMetaToTranslate, 'metaFieldId'));
        // order metas by metaFieldId and group by language, so each language array is ordered by metaFieldId
        this.questionMetaToTranslate = lodash.sortBy(this.questionMetaToTranslate, 'metaFieldId');
        this.questionMetaToTranslate = lodash.groupBy(this.questionMetaToTranslate, 'language');

        // this holds all available language codes as key and whether they are activated as value
        this.languages = {};
        lodash.forEach(this.TokenService.getCompanySupportedLanguages(), (code) => {
            this.languages[code] = lodash.has(this.question.questionI18ns, code);
            // if we do not have meta for this language in database
            if (!this.questionMetaToTranslate[code]) {
                this.questionMetaToTranslate[code] = lodash.map(this.metaFieldIds, (metaFieldId) => {
                    return { language: code, metaFieldId };
                });
            }
            // in case some meta is not saved for not default language - assign metaFieldId and language
            else {
                lodash.forEach(this.metaFieldIds, (metaFieldId, key) => {
                    const compareFieldId = lodash.get(this.questionMetaToTranslate, `${code}.${key}.metaFieldId`, -1);
                    // if some translation values are missing in "questionMetaToTranslate"
                    // then push empty object under missing "key"
                    if (parseInt(metaFieldId, 10) !== compareFieldId) {
                        this.questionMetaToTranslate[code].splice(key, 0, { language: code, metaFieldId });
                    }
                });
            }
        });

        this.defaultLanguageAnswers = lodash.filter(this.form.model.questionAnswersI18ns, (answerI18n) => {
            return answerI18n.language === this.defaultLanguage;
        });

        this.form.model.questionAnswers = angular.copy(this.updateForm.model.questionAnswers);

        this.mapChildQuestionsWithTranslations();

        this.ckconfig = this.CkEditorService.getDefaultConfig();

        this.ckconfigForName = {
            toolbar: [
                { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline'] },
                { name: 'paragraph', items: ['NumberedList', 'BulletedList'] }
            ]
        };
    }

    mapChildQuestionsWithTranslations () {
        if (!this.form.model.childQuestions || !this.form.model.childQuestions.length) {
            return;
        }

        this.lodash.forEach(this.form.model.childQuestions, (childQuestion, childQkey) => {
            this.lodash.forEach(this.form.model.childQuestionsActiveI18ns, (childQuestionI18n) => {
                if (!this.form.model.childQuestions[childQkey].questionI18ns) {
                    this.form.model.childQuestions[childQkey].questionI18ns = {};
                }
                if (!this.form.model.childQuestions[childQkey].questionI18ns[childQuestionI18n.language]) {
                    this.form.model.childQuestions[childQkey].questionI18ns[childQuestionI18n.language] = {};
                }
                if (childQuestionI18n.questionId === childQuestion.id) {
                    this.form.model.childQuestions[childQkey].questionI18ns[childQuestionI18n.language] = childQuestionI18n;
                }
            });
        });

        this.lodash.forEach(this.TokenService.getCompanySupportedLanguages(), (code) => {
            this.lodash.forEach(this.form.model.childQuestions, (childQuestion, childQkey) => {
                if (!this.form.model.childQuestions[childQkey].questionI18ns[code]) {
                    this.form.model.childQuestions[childQkey].questionI18ns[code] = {};
                }
            });
        });
    }

    toggleCheckbox (code) {
        const confirmMessage = this.$translate.instant('translations.Are you sure you would like to remove this translation?');

        if (!this.languages[code]) {
            // leave checkbox checked
            this.languages[code] = !this.languages[code];
            this.ModalService.confirm(confirmMessage, 'medium')
                .then(() => {
                    // uncheck if confirmed
                    this.languages[code] = !this.languages[code];
                    // if language is disabled, make sure no error messages are left in ui
                    if (this.lodash.has(this.form.errors.questionI18ns, code)) {
                        delete this.form.errors.questionI18ns[code];
                    }
                    this.lodash.forEach(this.form.model.questionAnswers, (answer, key) => {
                        delete this.form.model.questionAnswers[key].translations[code];
                    });

                    this.lodash.forEach(this.questionMetaToTranslate, () => {
                        delete this.questionMetaToTranslate[code];
                    });

                    if (this.form.model.childQuestions) {
                        this.lodash.forEach(this.form.model.childQuestions, (childQuestion, key) => {
                            if (childQuestion.questionI18ns[code]) {
                                delete this.form.model.childQuestions[key].questionI18ns[code];
                            }
                        });
                    }
                });
        }
        else {
            // if language is enabled and form does not have current i18n, make one
            if (!this.lodash.has(this.form.model.questionI18ns, code)) {
                this.form.model.questionI18ns[code] = {};
            }
            this.lodash.forEach(this.form.model.questionAnswers, (answer, key) => {
                this.form.model.questionAnswers[key].translations[code] = {};
            });

            if (this.form.model.childQuestions) {
                this.lodash.forEach(this.form.model.childQuestions, (childQuestion, key) => {
                    if (!childQuestion.questionI18ns[code]) {
                        this.form.model.childQuestions[key].questionI18ns[code] = {};
                    }
                });
            }

            if (!this.questionMetaToTranslate[code]) {
                this.lodash.forEach(this.metaFieldIds, (metaFieldId) => {
                    this.questionMetaToTranslate[code] = [];
                    this.questionMetaToTranslate[code].push({ language: code, metaFieldId });
                });
            }
        }
    }

    deleteDisabledTranslations () {
        this.lodash.forEach(this.languages, (isActive, code) => {
            // if language is not active delete it from form
            if (!isActive && this.lodash.has(this.form.model.questionI18ns, code)) {
                delete this.form.model.questionI18ns[code];
            }

            if (!isActive) {
                this.lodash.forEach(this.form.model.questionAnswers, (answer, key) => {
                    delete this.form.model.questionAnswers[key].translations[code];
                });
                this.lodash.forEach(this.questionMetaToTranslate, () => {
                    delete this.questionMetaToTranslate[code];
                });
                if (this.form.model.childQuestions) {
                    this.lodash.forEach(this.form.model.childQuestions, (childQuestion, key) => {
                        if (childQuestion.questionI18ns[code]) {
                            delete this.form.model.childQuestions[key].questionI18ns[code];
                        }
                    });
                }
            }
        });
    }

    setMetaToForm () {
        this.form.model.questionMeta = [];
        this.lodash.forEach(this.questionMetaToTranslate, (metaItem) => {
            this.lodash.forEach(metaItem, (meta) => {
                const index = this.lodash.findIndex(this.form.model.questionMeta, (metaToCompare) => {
                    return (meta.id ? metaToCompare.id === meta.id : false);
                });

                if (meta.value) {
                    if (index >= 0) {
                        this.form.model.questionMeta[index] = meta;
                    }
                    else {
                        this.form.model.questionMeta.push(meta);
                    }
                }
            });
        });
    }

    setQuestionSiteIds () {
        this.form.model.questionSiteIds = [];
        if (this.form.model.siteAccess === this.FORMS_SITE_ACCESS_ENUM.KEYS.ALL_SITES) {
            this.form.model.questionSiteIds = [];
        }
        else {
            this.form.model.questionSiteIds = this.form.model.sites.map(site => site.id);
        }
    }

    save (confirmed = false) {
        this.setQuestionSiteIds();
        this.deleteDisabledTranslations();
        this.setMetaToForm();

        this.generalErrors = [];
        const params = {};
        if (confirmed) {
            params.confirmUpdate = true;
        }

        this.form.save(params).then((model) => {
            this.$scope.$emit('question:reload', model);
            this.updateForm.model = model;
            this.sortAnswers();
            this.initMetaFields();
            this.update();
        }).catch(response => {
            this.handleResponse(response);
        });
    }

    handleResponse (response) {
        const msg = this.QuestionConfirmService.getConfirmationMessage(response);
        if (msg) {
            // we do not wanna show form errors when "confirm" validation error
            this.form.cleanErrors();
            this.ModalService.confirm(msg, 'medium').then(() => this.save(true));
        }
        else {
            this.generalErrors = this.QuestionFormService.getAnswerErrors(this.form);
        }
    }

    sortAnswers () {
        // Sort translations to be indexed by language
        if (this.updateForm.model.questionAnswers) {
            this.lodash.forEach(this.updateForm.model.questionAnswers, (answer) => {
                this.updateForm.model.questionAnswers[answer.sequence].translations = {};

                this.updateForm.model.questionAnswers[answer.sequence].translations = this.lodash.reduce(this.updateForm.model.questionAnswersI18ns, (origin, answerI18n) => {
                    if (answerI18n.answerId === answer.id) {
                        if (!origin[answerI18n.language]) {
                            origin[answerI18n.language] = {};
                        }
                        origin[answerI18n.language] = answerI18n;
                    }
                    return origin;
                }, {});
            });
        }
    }

    initMetaFields () {
        this.questionMetaFields = {};
        if (this.updateForm.model.questionMeta) {
            this.questionMetaFields = this.lodash.reduce(this.updateForm.model.questionMeta, (origin, meta) => {
                if (meta.metaFieldValueId) {
                    meta.metaFieldValueId = meta.metaFieldValueId.toString();
                }

                origin[meta.metaFieldId] = meta;
                return origin;
            }, {});
        }
    }

    isCheckboxOrRadio () {
        return this.form.model.type === this.QUESTIONS_TYPE_ENUM.KEYS.RADIO ||
            this.form.model.type === this.QUESTIONS_TYPE_ENUM.KEYS.CHECKBOX;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/question/translation/index.js